const data = 
[
    {
        "brand": "索尼",
        "camera": "RX100 Ⅶ",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V103",
        "note": "1、相机蓝牙遥控设置方法：\n-网络2→Bluetooth遥控→开；\n-Bluetooth设置→Bluetooth功能→开；\n-Bluetooth设置→配对；\n-打开相机蓝牙：进入相机设置菜单，选择网络→Bluetooth设置→Bluetooth\n2、云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n3、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "索尼",
        "camera": "A6100",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1、相机蓝牙遥控设置方法：\n-打开相机蓝牙：进入相机设置菜单，选择网络→Bluetooth设置→Bluetooth功能→开。\n-打开蓝牙遥控：网络→传输/远程→Bluetooth遥控→开；\n-蓝牙配对/连接：网络→Bluetooth设置→配对；\n-云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n2、由于部分相机系统限制，仅在蓝牙配对状态下，无法实现相机控制，需同时确保Bluetooth遥控设置为开启状态。\n3、由于蓝牙快门优先级较高，如需连接相机控制线调节相机参数，如光圈，快门，ISO等，需要先在云台蓝牙设置界面断开相机蓝牙，然后才能使用相应功能。\n4、清空配对：\n相机menu，网络，网络选项，复位网络设置，点击确定"
    },
    {
        "brand": "索尼",
        "camera": "A6400",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1、相机蓝牙遥控设置方法：\n-打开相机蓝牙：进入相机设置菜单，选择网络→Bluetooth设置→Bluetooth功能→开。\n-打开蓝牙遥控：网络→传输/远程→Bluetooth遥控→开；\n-蓝牙配对/连接：网络→Bluetooth设置→配对；\n-云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n2、由于部分相机系统限制，仅在蓝牙配对状态下，无法实现相机控制，需同时确保Bluetooth遥控设置为开启状态。\n3、由于蓝牙快门优先级较高，如需连接相机控制线调节相机参数，如光圈，快门，ISO等，需要先在云台蓝牙设置界面断开相机蓝牙，然后才能使用相应功能。\n5、清空配对：\n相机menu，网络，网络选项，复位网络设置，点击确定"
    },
    {
        "brand": "索尼",
        "camera": "A6700",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V103",
        "note": "1、相机蓝牙遥控设置方法：\n-打开相机蓝牙：进入相机设置菜单，选择网络→Bluetooth设置→Bluetooth功能→开。\n-打开蓝牙遥控：网络→传输/远程→Bluetooth遥控→开；\n-蓝牙配对/连接：网络→Bluetooth设置→配对；\n-云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n2、由于部分相机系统限制，仅在蓝牙配对状态下，无法实现相机控制，需同时确保Bluetooth遥控设置为开启状态。\n3、由于蓝牙快门优先级较高，如需连接相机控制线调节相机参数，如光圈，快门，ISO等，需要先在云台蓝牙设置界面断开相机蓝牙，然后才能使用相应功能。\n6、清空配对：\n相机menu，网络，网络选项，复位网络设置，点击确定"
    },
    {
        "brand": "索尼",
        "camera": "ZV-1M2",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V103",
        "note": "1、相机蓝牙遥控设置方法：\n-打开相机蓝牙：进入相机设置菜单，选择网络→Bluetooth设置→Bluetooth功能→开。\n-打开蓝牙遥控：网络→传输/远程→Bluetooth遥控→开；\n-蓝牙配对/连接：网络→Bluetooth设置→配对；\n-云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n2、由于部分相机系统限制，仅在蓝牙配对状态下，无法实现相机控制，需同时确保Bluetooth遥控设置为开启状态。\n3、由于蓝牙快门优先级较高，如需连接相机控制线调节相机参数，如光圈，快门，ISO等，需要先在云台蓝牙设置界面断开相机蓝牙，然后才能使用相应功能。\n7、清空配对：\n相机menu，网络，网络选项，复位网络设置，点击确定"
    },
    {
        "brand": "索尼",
        "camera": "A7C Ⅱ",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1、相机蓝牙遥控设置方法：\n-打开相机蓝牙：进入相机设置菜单，选择网络→Bluetooth设置→Bluetooth功能→开。\n-打开蓝牙遥控：网络→传输/远程→Bluetooth遥控→开；\n-蓝牙配对/连接：网络→Bluetooth设置→配对；\n-云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n2、由于部分相机系统限制，仅在蓝牙配对状态下，无法实现相机控制，需同时确保Bluetooth遥控设置为开启状态。\n3、由于蓝牙快门优先级较高，如需连接相机控制线调节相机参数，如光圈，快门，ISO等，需要先在云台蓝牙设置界面断开相机蓝牙，然后才能使用相应功能。\n8、清空配对：\n相机menu，网络，网络选项，复位网络设置，点击确定"
    },
    {
        "brand": "索尼",
        "camera": "A7R V",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1、相机蓝牙遥控设置方法：\n-打开相机蓝牙：进入相机设置菜单，选择网络→Bluetooth设置→Bluetooth功能→开。\n-打开蓝牙遥控：网络→传输/远程→Bluetooth遥控→开；\n-蓝牙配对/连接：网络→Bluetooth设置→配对；\n-云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n2、由于部分相机系统限制，仅在蓝牙配对状态下，无法实现相机控制，需同时确保Bluetooth遥控设置为开启状态。\n3、由于蓝牙快门优先级较高，如需连接相机控制线调节相机参数，如光圈，快门，ISO等，需要先在云台蓝牙设置界面断开相机蓝牙，然后才能使用相应功能。\n9、清空配对：\n相机menu，网络，网络选项，复位网络设置，点击确定"
    },
    {
        "brand": "索尼",
        "camera": "ZV-1",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 2.01,
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1、相机蓝牙遥控设置方法：\n-打开相机蓝牙：进入相机设置菜单，选择网络→Bluetooth设置→Bluetooth功能→开。\n-打开蓝牙遥控：网络→传输/远程→Bluetooth遥控→开；\n-蓝牙配对/连接：网络→Bluetooth设置→配对；\n-云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n2、由于部分相机系统限制，仅在蓝牙配对状态下，无法实现相机控制，需同时确保Bluetooth遥控设置为开启状态。\n3、由于蓝牙快门优先级较高，如需连接相机控制线调节相机参数，如光圈，快门，ISO等，需要先在云台蓝牙设置界面断开相机蓝牙，然后才能使用相应功能。\n10、清空配对：\n相机menu，网络，网络选项，复位网络设置，点击确定"
    },
    {
        "brand": "索尼",
        "camera": "A7C",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1、相机蓝牙遥控设置方法：\n-打开相机蓝牙：进入相机设置菜单，选择网络→Bluetooth设置→Bluetooth功能→开。\n-打开蓝牙遥控：网络→传输/远程→Bluetooth遥控→开；\n-蓝牙配对/连接：网络→Bluetooth设置→配对；\n-云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n2、由于部分相机系统限制，仅在蓝牙配对状态下，无法实现相机控制，需同时确保Bluetooth遥控设置为开启状态。\n3、由于蓝牙快门优先级较高，如需连接相机控制线调节相机参数，如光圈，快门，ISO等，需要先在云台蓝牙设置界面断开相机蓝牙，然后才能使用相应功能。\n11、清空配对：\n相机menu，网络，网络选项，复位网络设置，点击确定"
    },
    {
        "brand": "索尼",
        "camera": "A7R Ⅳ",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.20",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1、相机蓝牙遥控设置方法：\n-打开相机蓝牙：进入相机设置菜单，选择网络→Bluetooth设置→Bluetooth功能→开。\n-打开蓝牙遥控：网络→传输/远程→Bluetooth遥控→开；\n-蓝牙配对/连接：网络→Bluetooth设置→配对；\n-云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n2、由于部分相机系统限制，仅在蓝牙配对状态下，无法实现相机控制，需同时确保Bluetooth遥控设置为开启状态。\n3、由于蓝牙快门优先级较高，如需连接相机控制线调节相机参数，如光圈，快门，ISO等，需要先在云台蓝牙设置界面断开相机蓝牙，然后才能使用相应功能。\n12、清空配对：\n相机menu，网络，网络选项，复位网络设置，点击确定"
    },
    {
        "brand": "索尼",
        "camera": "A7 IV",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1、相机蓝牙遥控设置方法：\n-打开相机蓝牙：进入相机设置菜单，选择网络→Bluetooth设置→Bluetooth功能→开。\n-打开蓝牙遥控：网络→传输/远程→Bluetooth遥控→开；\n-蓝牙配对/连接：网络→Bluetooth设置→配对；\n-云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n2、由于部分相机系统限制，仅在蓝牙配对状态下，无法实现相机控制，需同时确保Bluetooth遥控设置为开启状态。\n3、由于蓝牙快门优先级较高，如需连接相机控制线调节相机参数，如光圈，快门，ISO等，需要先在云台蓝牙设置界面断开相机蓝牙，然后才能使用相应功能。\n13、清空配对：\n相机menu，网络，网络选项，复位网络设置，点击确定"
    },
    {
        "brand": "索尼",
        "camera": "A7S Ⅲ",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.10",
        "blueToothFirmware": "Bluetooth_V103",
        "note": "1、相机蓝牙遥控设置方法：\n-打开相机蓝牙：进入相机设置菜单，选择网络→Bluetooth设置→Bluetooth功能→开。\n-打开蓝牙遥控：网络→传输/远程→Bluetooth遥控→开；\n-蓝牙配对/连接：网络→Bluetooth设置→配对；\n-云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n2、由于部分相机系统限制，仅在蓝牙配对状态下，无法实现相机控制，需同时确保Bluetooth遥控设置为开启状态。\n3、由于蓝牙快门优先级较高，如需连接相机控制线调节相机参数，如光圈，快门，ISO等，需要先在云台蓝牙设置界面断开相机蓝牙，然后才能使用相应功能。\n14、清空配对：\n相机menu，网络，网络选项，复位网络设置，点击确定"
    },
    {
        "brand": "索尼",
        "camera": "ZV-E10",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1、相机蓝牙遥控设置方法：\n-MENU→网络2→Bluetooth遥控→开。\n-网络1→Bluetooth设置→Bluetooth功能→开；\n-蓝牙配对：网络1→Bluetooth设置→配对；\n2、云台主屏从右往左滑，点击蓝牙设置，打开相机控制，选择对应相机蓝牙名称，点击连接，等待配对成功；\n3、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "EOS 200D Ⅱ",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.3",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1、无线设置→蓝牙设置→蓝牙→启用；\n2、无线设置→Wi-Fi/蓝牙连接→连接至无线遥控器-添加要连接的设备\n3、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机名称\n4、相机切换到拍照模式：相机切到拍照模式→驱动模式→自拍：10秒/遥控\n5、相机切换到录像模式：相机切录像模式→遥控→启用\n6、关闭电源设置：设置→节电→自动关闭电源→关闭\n7、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "EOS M50",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.1.0",
        "blueToothFirmware": "Bluetooth_V103",
        "note": "1、无线通信设置→蓝牙功能→蓝牙功能→遥控器\n2、无线通信设置→蓝牙功能→配对；（如果配对项是灰色，请先到查看/清除连接信息，INFO清除设置，再重新配对）\n3、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机名称\n4、相机切换到拍照模式：驱动模式→自拍：遥控（10s、2s都可以，但必须要是遥控）\n5、相机切换到录像模式：相机切录像模式→拍摄和记录→遥控→启用\n6、关闭电源设置：设置→节电→自动关闭电源→关闭\n7、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "EOS R",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.8.0",
        "blueToothFirmware": "Bluetooth_V103",
        "note": "1、无线通信设置→蓝牙功能→蓝牙功能→遥控器；\n2、无线通信设置→蓝牙功能→配对；（如果配对项是灰色，请先到查看/清除连接信息，INFO清除设置，再重新配对）\n3、云台主页面从右向左滑→蓝牙设置→相机控制→打开，点击相应的相机名称→确认配对\n4、相机切换到手动拍照模式：单击实体按钮SET键→驱动模式→自拍：10s遥控（或自拍：2s遥控）\n5、相机切换到手动录像模式：点击MENU→     →遥控→启用\n6、关闭电源设置：     →节电→自动关闭电源→关闭\n7、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "EOS R6",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.8.2",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1、无线功能→蓝牙设置→蓝牙→启用\n2、无线功能→Wi-Fi/蓝牙连接→连接至无线遥控器\n3、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机名称\n4、相机切换到拍照模式：驱动模式→自拍：遥控（10s、2s都可以，但必须要是遥控）\n5、相机切换到录像模式：相机切录像模式→拍摄和记录→遥控→启用\n6、关闭电源设置：设置→节电→自动关闭电源→关闭\n7、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "EOS R7",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.3.1",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1、无线功能→蓝牙设置→蓝牙→启用；\n2、无线功能→Wi-Fi/蓝牙连接→连接至无线遥控器-添加要连接的设备\n3、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机名称\n4、相机切换到拍照模式：驱动模式→自拍：10秒/遥控或自拍：2秒/遥控\n5、相机切换到录像模式：相机切录像模式→遥控→启用\n6、关闭电源设置：设置→节电→自动关闭电源→关闭\n7、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "EOS R10",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.2.0",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1、无线功能→蓝牙设置→蓝牙→启用；\n2、无线功能→Wi-Fi/蓝牙连接→连接至无线遥控器-添加要连接的设备\n3、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机名称\n4、相机切换到拍照模式：单击相机Q按键，驱动模式→自拍：10秒/遥控或自拍：2秒/遥控\n5、相机切换到录像模式：相机切录像模式→遥控→启用\n6、关闭电源设置：设置→节电→自动关闭电源→关闭\n7、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "EOS R50",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1、蓝牙设置→蓝牙→启用\n2、连接至无线遥控器→添加要连接的设备\n3、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机名称\n4、关闭电源设置：设置→节电→自动关闭电源→关闭\n5、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "EOS R5C",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "×",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.5.1",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1、无线通信设置→蓝牙设置→启用；\n2、无线通信设置→WI-FI蓝牙连接→连接至无线遥控器→添加要连接的设备；\n3、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机名称\n4、驱动模式→自拍：10秒/遥控或自拍：2秒/遥控\n5、关闭电源设置：设置→节电→自动关闭电源→关闭\n6、请确保相机是在拍照模式下开机"
    },
    {
        "brand": "佳能",
        "camera": "EOS M50 Mark Ⅱ",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1、无线通信设置→蓝牙功能→蓝牙功能→遥控器；\n2、无线通信设置→蓝牙功能→配对；（如果配对项是灰色，请先到查看/清除连接信息，INFO清除设置，再重新配对）\n3、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机名称\n4、相机切换到拍照模式：驱动模式→自拍：10秒/遥控或自拍：2秒/遥控\n5、相机切换到录像模式：相机切录像模式→遥控→启用\n6、关闭电源设置：设置→节电→自动关闭电源→关闭\n7、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "EOS RP",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.6.0",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1、无线通信设置→蓝牙功能→蓝牙功能→遥控器；\n2、无线通信设置→蓝牙功能→配对；（如果配对项是灰色，请先到查看/清除连接信息，INFO清除设置，再重新配对）\n3、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机名称\n4、相机切换到拍照模式：驱动模式→自拍：10秒/遥控或自拍：2秒/遥控\n5、相机切换到录像模式：相机切录像模式→遥控→启用\n6、关闭电源设置：设置→节电→自动关闭电源→关闭\n7、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "Powershot G7 X Mark Ⅲ",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.3.0",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1、无线通信设置→蓝牙设置→启用；\n2、无线通信设置→Wi-Fi/蓝牙连接→连接至无线遥控器\n3、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机名称\n4、相机切换拍照模式：驱动模式→自拍定时器：10秒或自拍定时器：2秒\n5、相机切换录像模式：相机切录像模式→遥控→启用\n6、关闭电源设置：设置→节电→自动关闭电源→关闭\n7、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "EOS M6 Mark Ⅱ",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.1.1",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1、无线通信设置→蓝牙设置→启用；\n2、无线通信设置→Wi-Fi/蓝牙连接→连接至无线遥控器\n3、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机名称\n4、相机切换到拍照模式：驱动模式→自拍：10秒/遥控或2秒/遥控\n5、相机切换到录像模式：相机切录像模式→遥控→启用\n6、关闭电源设置：设置→节电→自动关闭电源→关闭\n7、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "佳能",
        "camera": "EOS R5",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.9.0",
        "blueToothFirmware": "Bluetooth_V105",
        "note": "1、无线通信设置→蓝牙设置→启用；\n2、无线通信设置→Wi-Fi/蓝牙连接→连接至无线遥控器\n3、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机名称\n4、相机切换到拍照模式：驱动模式→自拍：10秒/遥控或2秒/遥控\n5、相机切换到录像模式：相机切录像模式→遥控→启用\n6、关闭电源设置：设置→节电→自动关闭电源→关闭\n7、拍照时，请将相机拍摄模式切换至拍照。录像时，请将相机拍摄模式切换至录像；"
    },
    {
        "brand": "尼康",
        "camera": "Z30",
        "controlFunction": "蓝牙控制",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.10",
        "blueToothFirmware": "Bluetooth_V104",
        "note": "1、相机设定菜单→无线遥控（ML-L7)选项）→无线遥控连接→启用\n2、云台主页面右滑→蓝牙设置→相机控制打开，选择扫描出的相机蓝牙名称连接\n3、由于相机系统原因，需要拍照时，请将相机拍摄模式切换至拍照。需要录像时，请将相机拍摄模式切换至录像"
    }
]

export default data